module.exports = __webpack_public_path__ + "img/spread_rule.16f0c8ca.png";